import { writable } from "svelte/store";

export const alreadyAskForInitCryptoConfiguration = writable(false);
